enum PortalTabs {
    Users = '/users',
    Classes = '/classes',
    Profile = '/profile',
    Planner = '/planner',
    ClassSessions = '/class-sessions',
    Insights = '/insights',
    Settings = '/settings',
    Troubleshooting = '/troubleshooting',
    Feedback = '/feedback',
    Support = '/support',
    Data = '/data',
    AskTheAI = '/asktheai',
    Home = '/home'
}

export { PortalTabs };
